export const colorWhite = '#FBFBFB';
export const colorMaximusDark = '#D0234A';
export const colorMint = '#4ED8DE';
export const colorCard = '#0F0C0D';
